import { Button, Result } from "antd";
import { Link } from "react-router-dom";

function Forbidden() {
  return (
    <div>
      <Result
        status="403"
        title="403"
        subTitle="No tienes permiso para acceder a esta sección."
        extra={
          <Button type="primary">
            <Link to={"/admin/profile"}>Regresar</Link>
          </Button>
        }
      />
    </div>
  );
}

export default Forbidden;
